import hsFetch from 'hellospa/hs-fetch';

// This should match the type of whatever the BE sends, so I think it makes
// sense to define the type in the same file that fetches the data. -Asa
export type GroupSettings = {
  groups: string[]
}

export async function getGroupSettings(): Promise<GroupSettings> {
  // hsFetch handles the CSRF token for you
  const result = await hsFetch('/example');
  const data = await result.json();
  return data;
}
